import { createTypes, createAsyncTypes } from '../../utils';

const prefix = 'myLounge';

const types = createTypes(prefix, [
    'UPDATE_SLIDE_INDEX',
    'FILTER_CHANGED',
    'TOGGLE_WELCOME_BOX',
    'CLOSE_WELCOME_BOX',
    'RESET_CACHE',
    'UPDATE_IMAGES_LOADED',
]);

const asyncTypes = createAsyncTypes(prefix, [
    'UPDATE_OPEN_CAMPAIGNS',
    'UPDATE_MYLOUNGE',
    'FETCH_MY_RECO',
]);

export default {
    ...types,
    ...asyncTypes
};
